import { createContext, PropsWithChildren } from 'react';
import { useBreakpointsManager } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { IBreakpointsContext } from '@/providers/BreakpointsProvider/BreakpointsContext.types';

export const BreakpointsContext = createContext<Partial<IBreakpointsContext>>({});

export const BreakpointsProvider = ({ children }: PropsWithChildren) => {
  const { isDesktop } = useBreakpointsManager();

  const VALUE: IBreakpointsContext = {
    isDesktop,
  };

  return <BreakpointsContext.Provider value={VALUE}>{children}</BreakpointsContext.Provider>;
};
